// HeraLabX Technical KPI -> raw KNVB player-stats CSV field(s). KNVB fully replaced SciSports
// as the Technical Stats source (2026-08-17, confirmed with the club) — this file used to
// mirror technicalImport.js's SciSports-side KPI_FIELD_MAP for the "Definitions & Mapping"
// button on the Technical Overview page; it now mirrors KNVB_KPI_FIELD_MAP instead, the same
// one-to-one relationship, just pointed at the live source. The old SciSports mapping isn't
// reproduced here even for historical matches still showing SciSports-sourced numbers in the
// table (technical_match_stats.source) — those rows keep their stored values regardless, this
// modal is a "how are today's numbers built" reference, not a historical audit trail.
//
// Unlike SciSports, KNVB never delivers a pre-computed accuracy/ratio column — every rate KPI's
// `derivedFrom` here is a formula HeraLabX itself actually applies (see technicalImport.js's
// computeKnvbRate), success field(s) divided by attempt field(s) × 100. `successFields: null`
// means volume-scored — no success/fail split exists in KNVB's data for that KPI (see
// pillarScores.js's VOLUME_KPI_BENCHMARK_PLACEHOLDER for how those are scored). `fields: null`
// means the KPI has no KNVB source at all.
export const TECHNICAL_KPI_MAPPING = [
  {
    kpiName: 'Duels (ground)',
    fields: ['tackle'], successFields: ['tackle_suc'],
    definition: 'Ground duels contested / won, tackle attempts and their successful subset.',
  },
  {
    kpiName: 'Shots',
    fields: ['shot'], successFields: ['sot'],
    definition: 'All shots (including penalties, free kicks, corners — not just open play) and how many were on target.',
  },
  {
    kpiName: 'Passes',
    fields: ['pass'], successFields: ['pass_suc'],
    definition: 'All passes attempted and completed.',
  },
  {
    kpiName: 'Dribbles',
    fields: ['carry'], successFields: null,
    definition: 'Ball carries — the closest KNVB proxy for a dribble. No success/fail split exists for this one, count only.',
  },
  {
    kpiName: '1v1 actions',
    fields: ['takeon'], successFields: ['takeon_suc'],
    definition: 'Take-ons attempted and won (attacking 1v1 situations).',
  },
  {
    kpiName: '1v1 (defensive)',
    fields: ['takeon'], successFields: ['takeon_suc'],
    definition: 'Same underlying fields as "1v1 actions" above — KNVB does not separately track a defensive take-on situation from an attacking one, both KPIs are built from the same take-on stat.',
  },
  {
    kpiName: 'Progressive Passes',
    fields: ['pass_progressive'], successFields: ['pass_progressive_suc'],
    definition: 'Passes that move the ball meaningfully forward, and how many of those were completed.',
  },
  {
    kpiName: 'switch play',
    fields: null, successFields: null,
    definition: 'Not available — only obtainable from KNVB\'s separate match-events file, which per a 2026-08-13 decision was not added.',
  },
  {
    kpiName: 'Crosses',
    fields: ['cross_early', 'cross_classic', 'cross_pullback', 'cross_other'],
    successFields: ['cross_early_suc', 'cross_classic_suc', 'cross_pullback_suc', 'cross_other_suc'],
    definition: 'Sum of KNVB\'s 4 cross sub-types (early, classic, pullback, other) and their combined success counts.',
  },
  {
    kpiName: 'Duels (air)',
    fields: ['aerial'], successFields: ['aerial_suc'],
    definition: 'Aerial duels contested and won.',
  },
  {
    kpiName: 'key passes',
    fields: ['pass_key'], successFields: null,
    definition: 'Passes that directly led to a shot. Volume-scored, no rate.',
  },
  {
    kpiName: 'Long balls',
    fields: ['pass_long'], successFields: ['pass_long_suc'],
    definition: 'Long passes attempted and completed.',
  },
  {
    kpiName: 'Underlap/overlap',
    fields: null, successFields: null,
    definition: 'Not available — no off-ball run tracking in KNVB\'s data (nor was there in SciSports\'s).',
  },
  {
    kpiName: 'Block shots',
    fields: ['blocked_shot'], successFields: null,
    definition: 'Opponent shots blocked. Volume-scored, no rate.',
  },
  {
    kpiName: 'headers',
    fields: ['shot_head'], successFields: null,
    definition: 'Headed shots — open-play and set-piece combined into one number, can\'t be split. Volume-scored, no rate.',
  },
];
